// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProfileGrant_profile-grant__wxgdU {
  margin-bottom: 25px;
  background: white;
  border-radius: 5px;
  padding: 15px 20px;
}`, "",{"version":3,"sources":["webpack://./src/Admin/Components/ProfileGrant/ProfileGrant.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AACF","sourcesContent":[".profile-grant {\n  margin-bottom: 25px;\n  background: white;\n  border-radius: 5px;\n  padding: 15px 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profile-grant": `ProfileGrant_profile-grant__wxgdU`
};
export default ___CSS_LOADER_EXPORT___;
